export const BOTTOM_NAVIGATION_HEIGHT = 56
export const BOTTOM_NAVIGATION_HEIGHT_LANDSCAPE = 42

export const MAX_PAGE_WIDTH = 1024

/* NavigationBar */
export const NAVIGATION_BAR_BORDER_WIDTH = 1
export const NAVIGATION_BAR_HEIGHT = 56
export const NAVIGATION_BAR_HEIGHT_TABLET = 64
export const NAVIGATION_BAR_HEIGHT_LANDSCAPE = 48

/* ContentSectionHeading */
export const CONTENT_SECTION_HEADING_TITLE_TYPOGRAPHY_VARIANT = 'h5'
export const CONTENT_SECTION_HEADING_TITLE_SPACING = [2.5, 0, 2, 0]
export const CONTENT_SECTION_HEADING_TITLE_SPACING_BOTTOM = 2

/* Theme Storage Key */
export const DARK_MODE_KEY = 'dark-mode-enabled'
